var portfolioPositionsTopFlop = {
	caption: {
		top: "Portfolio positions top results",
		flop: "Portfolio positions flop results",
		gainers: "Portfolio positions gainers",
		losers: "Portfolio positions losers"
	},
	name: "Libellé",
	isin: "ISIN",
	lastPrice: " Dernier prix",
	lastPriceDateTime: "Date/Heure",
	unrealizedPerformance: "Unrealized perf. in {currency}",
	unrealizedPerformanceRelative: "Gain/Perte %",
	unrealizedPerformanceBar: "Gain/Perte % of max",
	weight: "Poids %",
	marketValue: "Market value in {currency}",
	actions: "Actions",
	noPositions: "Aucun résultat trouvé"
};
var fr = {
	portfolioPositionsTopFlop: portfolioPositionsTopFlop
};

export { fr as default, portfolioPositionsTopFlop };
